import StandardPolicyReissue from "@/components/app/policyReissue/reissueTypes/StandardPolicyReissue.vue";

export default {
    StandardPolicyReissue,
};
